import moment from "moment";
import { IOfferedSubject, OfferSubject, Section } from "../types";
import { IInscribedSubject } from "../types/inscribedSubjects";

const findSectionByIdCurso = (sections: Section[], idCurso: number) => {
  return sections.find((section) => section.idCurso === idCurso);
};

/**
 * Función utilitaria para filtrar materias inscritas
 * @param inscribedSubjectsList Lista de materias inscritas
 * @param offeredSubjectsList Lista de materias ofrecidas (puede ser IOfferedSubject[] o OfferSubject[])
 * @returns Array de materias inscritas filtradas
 */
export const filterInscribedSubjectsByParams = (
  inscribedSubjectsList: IInscribedSubject[] | null,
  offeredSubjectsList: (IOfferedSubject | OfferSubject)[] | null
): IInscribedSubject[] => {
  const logPrefix = "[filterInscribedSubjectsByParams]";
  if (!inscribedSubjectsList || !Array.isArray(inscribedSubjectsList) || !offeredSubjectsList || !Array.isArray(offeredSubjectsList)) {
    return [];
  }

  const today = moment();
  let inscribedFiltered: IInscribedSubject[] = [];

  inscribedSubjectsList.forEach((inscribedSubject) => {
    // Validar que el subject tenga ID
    if (!inscribedSubject || !inscribedSubject.id) {
      console.log(`${logPrefix} Materia inscrita sin ID válido:`, inscribedSubject);
      return;
    }

    // 1. Verificar que la materia existe en la oferta
    const offeredSubject = offeredSubjectsList.find((offered) => {
      // Validar que el offered subject tenga ID
      if (!offered || !offered.id) {
        return false;
      }
      // Manejar ambos tipos de ID: string (IOfferedSubject) y number (OfferSubject)
      const offeredId = typeof offered.id === "string" ? offered.id : offered?.id?.toString();
      return offeredId === inscribedSubject?.id?.toString();
    });

    if (!offeredSubject) {
      console.log(`${logPrefix} Materia ${inscribedSubject.title || 'Sin título'} (ID: ${inscribedSubject.id}) no encontrada en oferta`);
      return;
    }

    // Validar que el subject tenga idCurso
    if (!inscribedSubject.idCurso) {
      console.log(`${logPrefix} Materia ${inscribedSubject.title || 'Sin título'} no tiene idCurso válido`);
      return;
    }

    // 2. Buscar la sección correspondiente en la materia ofrecida
    const offeredSection = findSectionByIdCurso(offeredSubject.sections as Section[], inscribedSubject.idCurso);
    if (!offeredSection) {
      console.log(`${logPrefix} Sección ${inscribedSubject.idCurso} no encontrada en materia ${offeredSubject.title || 'Sin título'}`);
      return;
    }

    // Validar que la sección tenga infoFechas
    if (!offeredSection.infoFechas) {
      console.log(`${logPrefix} Sección ${inscribedSubject.idCurso} no tiene infoFechas definida`);
      return;
    }

    // 3. Verificar que la fecha de finalización sea mayor al día actual
    const fechaFin = offeredSection.infoFechas.fechaFin;
    if (!fechaFin) {
      console.log(`${logPrefix} Materia ${inscribedSubject.title || 'Sin título'} no tiene fecha de finalización definida`);
      return;
    }

    const fechaFinMoment = moment.utc(fechaFin);

    if (!fechaFinMoment.isValid()) {
      console.log(`${logPrefix} Fecha de finalización inválida para materia ${inscribedSubject.title || 'Sin título'}: ${fechaFin}`);
      return;
    }

    const isActive = fechaFinMoment.isSameOrAfter(today, "day");

    if (!isActive) {
      console.log(`${logPrefix} Materia ${inscribedSubject.title || 'Sin título'} ya finalizó el ${fechaFinMoment.format("DD/MM/YYYY")}`);
    } else {
      inscribedFiltered.push(inscribedSubject);
    }
  });
  return inscribedFiltered;
};
